var exports = {
  "Nr": "x936d19a0--28dd8e--card",
  "UU": "x936d19a0--28dd8e--name",
  "_8": "x936d19a0--28dd8e--img",
};

module.exports = exports;
